import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { Button } from "primereact/button";
import ActiveDrivers from "./ActiveDrivers";
import { useEffect, useState, useCallback, useMemo } from "react";
import Logger from "../Logger";
import { getLoggerBaseURL } from "../../utils/getLoggerBaseURL";

const ActiveDriverLayout = ({ date, setDate }) => {
  const [activeDrivers, setActiveDrivers] = useState(null);

  const logger = useMemo(() => new Logger(getLoggerBaseURL()), []);

  const fetchActiveDrivers = useCallback(async () => {
    try {
      const response = await fetch(
        `/api/driverTesting/getActiveDrivers/ajay@gmail.com`,
        {
          method: "POST",
        },
      );

      const result = await response.json();
      setActiveDrivers(result?.driversList);
    } catch (error) {
      logger.log(`Error fetching active drivers: ${error}`, "ERROR");
    }
  }, [logger]);

  const dateOnChageHandler = (e) => {
    setDate(e.value);
  };

  const handleSearchDrivers = async () => {
    try {
      const formattedDate = date
        ? new Date(date).toISOString().split("T")[0]
        : null;

      const response = await fetch(
        `/api/driverTesting/getActiveDrivers/ajay@gmail.com`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ date: formattedDate }),
          credentials: "include", // to match { withCredentials: true }
        },
      );

      const data = await response.json();
      setActiveDrivers(data?.driversList);
    } catch (error) {
      logger.log(`Error fetching active drivers:" ${error}`, "ERROR");
    }
  };

  useEffect(() => {
    fetchActiveDrivers();
  }, [fetchActiveDrivers]);

  return (
    <div className="gap-3 p-fluid">
      <div className="flex items-start justify-between flex-wrap">
        <h2 className="text-2xl font-bold font-sans ml-8 mt-8">
          Active Drivers
        </h2>

        <div className="flex flex-wrap gap-4 items-end mr-8 ">
          <div>
            <label
              htmlFor="buttondisplay"
              className="font-bold block mb-2 font-sans"
            >
              Select Date
            </label>
            <Calendar
              className="w-72 h-10 border border-black rounded-md"
              value={date}
              onChange={(e) => dateOnChageHandler(e)}
              showIcon
            />
          </div>

          <div className="h-10 w-36">
            <Button
              className="w-full h-full px-4 py-3 border border-black rounded-md"
              label="Search"
              onClick={handleSearchDrivers}
            />
          </div>
        </div>
      </div>

      <div className="ml-2">
        {activeDrivers && <ActiveDrivers activeDrivers={activeDrivers} />}
      </div>
    </div>
  );
};

export default ActiveDriverLayout;
